module.exports = __webpack_public_path__ + "static/media/right-chevron-royal.9453917b.svg";